import { RenewVisaPresentUploadApplicationPage } from "@/features/renew-visa/pages/RenewVisaPresentUploadApplication";

const RenewVisaPresentUploadApplication = () => {
  return <RenewVisaPresentUploadApplicationPage />;
};

export default RenewVisaPresentUploadApplication;
